/* ================================================
   menopause-package.js
   Upload to: Shopify Admin > Themes > Edit Code > Assets
   ================================================ */

/* ──────────────────────────────────────────────
   ✏️  EDIT YOUR WHATSAPP NUMBER HERE
   Format: country code + number, no + or spaces
   India: 91 + 10-digit number = "919876543210"
────────────────────────────────────────────── */
const MPKG_WA_NUMBER = "917988074141";

/* ── Internal state ─────────────────────────── */
let _mpkgWaMsg = "";

/* ── Accordion toggle ───────────────────────── */
function mpkgToggle(btn) {
  var card    = btn.closest(".mpkg-test-card");
  var body    = card.querySelector(".mpkg-test-body");
  var chevron = btn.querySelector(".mpkg-chevron");
  var isOpen  = !body.hasAttribute("hidden");

  if (isOpen) {
    body.setAttribute("hidden", "");
    btn.setAttribute("aria-expanded", "false");
    chevron.textContent = "▼";
  } else {
    body.removeAttribute("hidden");
    btn.setAttribute("aria-expanded", "true");
    chevron.textContent = "▲";
  }
}

/* ── Modal open ─────────────────────────────── */
function mpkgOpenModal(type, preselect) {
  var title   = document.getElementById("mpkgModalTitle");
  var sub     = document.getElementById("mpkgModalSub");
  var pill    = document.getElementById("mpkgModalPill");
  var pkgSel  = document.getElementById("mpkgPackage");

  if (type === "callback") {
    title.textContent = "Get a Free Callback";
    sub.textContent   = "Share your details — our specialist will call within 2 hours.";
  } else {
    title.textContent = "Book Your Test";
    sub.textContent   = "Fill in your details — our team will reach out within 2 hours.";
  }

  /* Pre-select the package if one was passed */
  if (preselect && pkgSel) {
    for (var i = 0; i < pkgSel.options.length; i++) {
      if (pkgSel.options[i].text.indexOf(preselect.replace("&amp;", "&")) !== -1 ||
          pkgSel.options[i].value.indexOf(preselect) !== -1) {
        pkgSel.selectedIndex = i;
        break;
      }
    }
    /* Update pill to show selected package */
    if (pill && preselect) {
      pill.textContent = "📦 Selected: " + preselect.replace("&amp;", "&");
    }
  } else if (pill) {
    pill.textContent = "🎁 Menoweda partner discount applied on this booking";
  }

  document.getElementById("mpkgFormWrap").style.display = "block";
  document.getElementById("mpkgSuccess").classList.remove("mpkg-on");
  document.getElementById("mpkgModalBg").classList.add("mpkg-on");
  document.body.style.overflow = "hidden";

  setTimeout(function () {
    var first = document.getElementById("mpkgName");
    if (first) first.focus();
  }, 120);
}

/* ── Modal close ────────────────────────────── */
function mpkgClose() {
  document.getElementById("mpkgModalBg").classList.remove("mpkg-on");
  document.body.style.overflow = "";
}

/* Close on backdrop or ESC */
document.addEventListener("DOMContentLoaded", function () {
  var bg = document.getElementById("mpkgModalBg");
  if (bg) bg.addEventListener("click", function (e) { if (e.target === bg) mpkgClose(); });
});
document.addEventListener("keydown", function (e) { if (e.key === "Escape") mpkgClose(); });

/* ── WhatsApp (no form — sidebar/chat button) ── */
function mpkgWhatsApp() {
  var msg = encodeURIComponent(
    "Hi! I'd like to know more about the Menopause Wellness Packages through Menoweda."
  );
  window.open("https://wa.me/" + MPKG_WA_NUMBER + "?text=" + msg, "_blank");
}

/* ══════════════════════════════════════════════
   PINCODE AUTO-DETECT
   Uses: api.postalpincode.in
══════════════════════════════════════════════ */
var _mpkgPincodeTimer = null;

function mpkgPincodeInput(input) {
  /* Strip any non-digit characters as user types */
  var val = input.value.replace(/\D/g, "");
  input.value = val;

  var statusEl = document.getElementById("mpkgPincodeStatus");
  var rowEl    = document.getElementById("mpkgCityStateRow");
  var cityEl   = document.getElementById("mpkgCity");
  var stateEl  = document.getElementById("mpkgState");

  /* Reset on every keystroke */
  rowEl.style.display    = "none";
  cityEl.value           = "";
  stateEl.value          = "";
  statusEl.textContent   = "";
  statusEl.className     = "mpkg-pincode-status";

  /* Need exactly 6 digits */
  if (val.length < 6) return;

  /* Debounce — wait 400 ms after user stops typing */
  clearTimeout(_mpkgPincodeTimer);
  _mpkgPincodeTimer = setTimeout(function () {
    mpkgFetchPincode(val, statusEl, rowEl, cityEl, stateEl);
  }, 400);
}

function mpkgFetchPincode(pin, statusEl, rowEl, cityEl, stateEl) {
  statusEl.textContent = "🔍 Detecting…";
  statusEl.className   = "mpkg-pincode-status mpkg-pin-loading";

  /* ── Helper: fill UI on success ── */
  function fillSuccess(city, state) {
    cityEl.value         = city;
    stateEl.value        = state;
    rowEl.style.display  = "";
    statusEl.textContent = "✓";
    statusEl.className   = "mpkg-pincode-status mpkg-pin-ok";
  }

  function showError(msg) {
    statusEl.textContent = "✗ " + (msg || "Could not detect pincode");
    statusEl.className   = "mpkg-pincode-status mpkg-pin-err";
  }

  /* ── API 1: api.postalpincode.in (direct) ── */
  function tryAPI1() {
    return fetch("https://api.postalpincode.in/pincode/" + pin)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data[0] && data[0].Status === "Success" &&
            data[0].PostOffice && data[0].PostOffice.length > 0) {
          var po = data[0].PostOffice[0];
          fillSuccess(po.District || po.Division || po.Name || "", po.State || "");
          return true;
        }
        return false;
      });
  }

  /* ── API 2: postalpincode.in via corsproxy.io ── */
  function tryAPI2() {
    var url = "https://corsproxy.io/?url=https://api.postalpincode.in/pincode/" + pin;
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data[0] && data[0].Status === "Success" &&
            data[0].PostOffice && data[0].PostOffice.length > 0) {
          var po = data[0].PostOffice[0];
          fillSuccess(po.District || po.Division || po.Name || "", po.State || "");
          return true;
        }
        return false;
      });
  }

  /* ── API 3: Nominatim OpenStreetMap (most reliable, no key needed) ── */
  function tryAPI3() {
    var url = "https://nominatim.openstreetmap.org/search?postalcode=" + pin +
              "&countrycodes=in&format=json&addressdetails=1&limit=1";
    return fetch(url, { headers: { "Accept-Language": "en" } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.length > 0 && data[0].address) {
          var a = data[0].address;

          /* City: prefer district-level, fall back down to village */
          var city = a.county || a.city_district || a.city ||
                     a.town || a.suburb || a.village ||
                     a.state_district || "";

          /* State: OSM sometimes puts it in ISO code field or uses
             "state" directly — map common ISO codes to full names */
          var stateRaw = a.state || a["ISO3166-2-lvl4"] || "";
          var stateMap = {
            "IN-DL": "Delhi",        "IN-MH": "Maharashtra",
            "IN-KA": "Karnataka",    "IN-TN": "Tamil Nadu",
            "IN-UP": "Uttar Pradesh","IN-WB": "West Bengal",
            "IN-RJ": "Rajasthan",    "IN-GJ": "Gujarat",
            "IN-AP": "Andhra Pradesh","IN-TS": "Telangana",
            "IN-MP": "Madhya Pradesh","IN-BR": "Bihar",
            "IN-PB": "Punjab",       "IN-HR": "Haryana",
            "IN-OR": "Odisha",       "IN-KL": "Kerala",
            "IN-AS": "Assam",        "IN-JH": "Jharkhand",
            "IN-CG": "Chhattisgarh","IN-HP": "Himachal Pradesh",
            "IN-UK": "Uttarakhand",  "IN-JK": "Jammu and Kashmir",
            "IN-GA": "Goa",          "IN-MN": "Manipur",
            "IN-ML": "Meghalaya",    "IN-MZ": "Mizoram",
            "IN-NL": "Nagaland",     "IN-TR": "Tripura",
            "IN-AR": "Arunachal Pradesh","IN-SK": "Sikkim",
            "IN-CH": "Chandigarh",   "IN-PY": "Puducherry",
            "IN-AN": "Andaman and Nicobar Islands",
            "IN-DN": "Dadra and Nagar Haveli",
            "IN-DD": "Daman and Diu","IN-LD": "Lakshadweep"
          };
          var state = stateMap[stateRaw] || stateRaw || "";

          /* Last resort: if state still empty, try display_name parsing */
          if (!state && data[0].display_name) {
            var parts = data[0].display_name.split(",");
            /* display_name format: "area, district, state, India" */
            /* State is typically second-to-last before "India" */
            for (var i = parts.length - 1; i >= 0; i--) {
              var p = parts[i].trim();
              if (p && p !== "India" && p !== pin && isNaN(p)) {
                state = p;
                break;
              }
            }
          }

          if (city || state) {
            fillSuccess(city, state);
            return true;
          }
        }
        return false;
      });
  }

  /* ── Chain: try each API, move to next on failure/no result ── */
  tryAPI1()
    .catch(function () { return false; })
    .then(function (ok) {
      if (ok) return;
      return tryAPI2()
        .catch(function () { return false; })
        .then(function (ok2) {
          if (ok2) return;
          return tryAPI3()
            .catch(function () { return false; })
            .then(function (ok3) {
              if (!ok3) showError("Invalid or unrecognised pincode");
            });
        });
    });
}
/* ══════════════════════════════════════════════ */

/* ── Form submit ────────────────────────────── */
function mpkgSubmit(e) {
  e.preventDefault();

  var name    = (document.getElementById("mpkgName").value    || "").trim();
  var phone   = (document.getElementById("mpkgPhone").value   || "").trim();
  var age     = (document.getElementById("mpkgAge").value     || "Not shared").trim();
  var pincode = (document.getElementById("mpkgPincode").value || "").trim();
  var city    = (document.getElementById("mpkgCity").value    || "").trim();
  var state   = (document.getElementById("mpkgState").value   || "").trim();
  var pkg     = (document.getElementById("mpkgPackage").value || "").trim();
  var msg     = (document.getElementById("mpkgMsg").value     || "None").trim();

  /* Basic validation */
  if (!name || !phone || !pincode || !pkg) {
    alert("Please fill in all required fields.");
    return false;
  }

  if (pincode.length !== 6) {
    alert("Please enter a valid 6-digit pincode.");
    return false;
  }

  /* ── Optional: POST lead to webhook / CRM / Google Sheet ──────────
     Uncomment and replace URL to save leads server-side.
     Works with Zapier, Make (Integromat), or any REST endpoint.

  fetch("https://YOUR-WEBHOOK-URL.com/lead", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: name, phone: phone, age: age,
      pincode: pincode, city: city, state: state,
      package: pkg, message: msg,
      source: "menoweda-menopause-page",
      timestamp: new Date().toISOString()
    })
  }).catch(function(err) { console.warn("Webhook error:", err); });
  ────────────────────────────────────────────────────────────────── */

  /* Build WhatsApp pre-fill */
  var locationLine = pincode;
  if (city)  locationLine += " – " + city;
  if (state) locationLine += ", " + state;

  var waText =
    "*New Booking – Menoweda Menopause Package*\n\n" +
    "\uD83D\uDC64 Name: "      + name        + "\n" +
    "\uD83D\uDCF1 Phone: "     + phone       + "\n" +
    "\uD83C\uDF82 Age: "       + age         + "\n" +
    "\uD83D\uDCCD Location: "  + locationLine + "\n" +
    "\uD83D\uDCE6 Package: "   + pkg         + "\n" +
    "\uD83D\uDCAC Message: "   + msg         + "\n\n" +
    "_Sent from Menoweda website_";

  _mpkgWaMsg = encodeURIComponent(waText);

  /* Show success screen then redirect */
  document.getElementById("mpkgFormWrap").style.display = "none";
  document.getElementById("mpkgSuccess").classList.add("mpkg-on");
  setTimeout(mpkgWaFinal, 1400);

  return false;
}

function mpkgWaFinal() {
  window.open("https://wa.me/" + MPKG_WA_NUMBER + "?text=" + _mpkgWaMsg, "_blank");
}

/* ── Read More ──────────────────────────────── */
function mpkgReadMore(btn) {
  var more = document.querySelector(".mpkg-about-more");
  if (more) { more.removeAttribute("hidden"); }
  btn.style.display = "none";
}